import VanillaTilt from 'vanilla-tilt';
// import resolveConfig from 'tailwindcss/resolveConfig';
// import tailwindConfig from '../../tailwind.config';

// const tailwind = resolveConfig(tailwindConfig);
const { lg } = { lg: 1024 }; // tailwind.theme.screens;

export default class Tilt {
  constructor() {
    if (window.innerWidth < lg) {
      return;
    }

    document.querySelectorAll('.js-tilt').forEach($el => {
      VanillaTilt.init($el, {
        max: 5,
        scale: 1.05,
        speed: 700,
        glare: $el.dataset.tiltGlare !== undefined ? $el.dataset.tiltGlare === 'true' : true,
        "max-glare": 0.2,
        gyroscopeMinAngleX: -10,
        gyroscopeMaxAngleX: 10,
        gyroscopeMinAngleY: -10,
        gyroscopeMaxAngleY: 10,
      });
    });
  }
}
